<template>
    <div>
        <notifications
            :max="max"
            classes="inform-notification"
            group="inform"
            position="right bottom"
        >
        </notifications>
        <notifications
            :max="max"
            group="success"
            position="right bottom"
            width="25rem"
        >
            <template slot="body" slot-scope="props">
                <div class="custom-notif success">
                    <div class="notif-icon">
                        <i class="material-icons">check_circle_outline</i>
                    </div>
                    <div class="notif-content">
                        <a class="notif-title">
                            {{ props.item.title }}
                        </a>
                        <div v-html="props.item.text"></div>
                    </div>
                </div>
            </template>
        </notifications>
        <notifications
            :max="max"
            group="error"
            position="right bottom"
            width="25rem"
        >
            <template slot="body" slot-scope="props">
                <div class="custom-notif error">
                    <div class="notif-icon">
                        <i class="material-icons">error_outline</i>
                    </div>
                    <div class="notif-content">
                        <a class="notif-title">
                            {{ props.item.title }}
                        </a>
                        <div v-html="props.item.text"></div>
                    </div>
                </div>
            </template>
        </notifications>
    </div>
</template>
<script>
export default {
    data() {
        return {
            max: 4
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-notif {
    padding: 1rem 1rem;
    margin: 1rem;
    z-index: $toast;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-left: 5px solid transparent;
    color: #fff !important;

    &.success {
        border-left-color: #42a85f;
        background: $accent-apple;
    }
    &.error {
        border-left-color: #b82e24;
        background: $accent-red;
    }
}
.notif-icon {
    margin-right: 1rem;
    i {
        font-size: 2rem;
    }
}
.notif-title {
    font-family: $input-family;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    color: #fff !important;
}
</style>
